module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-29.454795af.png";